import { ArrowLeft, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { t } from "@/i18n/pl";

/**
 * Public RODO notice for the app — reachable from the signup form before any
 * account exists, and from the footer inside the app. App-specific facts
 * (what is collected, who sees the phone number, retention) live here; the
 * controller's full policy on zmskiba.pl is linked for legal bases and rights.
 */
export function PrivacyPage() {
  return (
    <div className="bg-background flex min-h-svh flex-col">
      <header className="bg-sidebar text-sidebar-foreground shadow-md">
        <div className="mx-auto flex h-14 w-full max-w-3xl items-center gap-3 px-4 sm:h-16">
          <img src="/logo.png" alt="ZM SKIBA S.A." className="h-8 w-auto sm:h-9" />
          <span className="font-semibold">{t.appName}</span>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
        <h1 className="text-2xl font-bold tracking-tight">{t.privacy.title}</h1>
        <p className="text-muted-foreground mt-1">{t.privacy.subtitle}</p>
        <p className="text-muted-foreground/70 mt-1 text-xs">{t.privacy.updated}</p>

        <p className="mt-6 text-sm leading-relaxed">
          {t.privacy.intro}{" "}
          <a
            href={t.privacy.corporatePolicyUrl}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            {t.privacy.corporatePolicy}
          </a>
          .
        </p>

        {t.privacy.sections.map((section) => (
          <section key={section.heading} className="mt-7">
            <h2 className="text-lg font-semibold">{section.heading}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="mt-2 text-sm leading-relaxed">
                {paragraph}
              </p>
            ))}
            {section.bullets && (
              <ul className="mt-2 list-disc space-y-1.5 pl-5 text-sm leading-relaxed">
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="mt-10 flex flex-wrap gap-3">
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft />
              {t.common.back}
            </Link>
          </Button>
          <Button asChild variant="ghost">
            <a href={t.privacy.corporatePolicyUrl} target="_blank" rel="noreferrer">
              {t.privacy.corporatePolicy}
              <ExternalLink />
            </a>
          </Button>
        </div>
      </main>
    </div>
  );
}
